import dayjs from "dayjs";
import {
  CalculationType,
  DebtorType,
} from "us.collection.admin/components/ManageFee/Constants";

export const initialValues = {
  feeTypeName: "",
  description: "",
  fromDate: dayjs(),
  debtorType: DebtorType.P,
};

export const feeRangeInitialValues = {
  fromAmount: 0,
  toAmount: 0,
  calculationType: CalculationType.RATE,
  feeRate: 0,
  baseAmount: 0,
  reminderFee: 0,
  collectionFee: 0,
};
